const countries: { [key: string]: { flag: string, name: string } } = {
  'fr-FR': {
    flag: '/assets/flags/france.svg',
    name: 'Français'
  },
  'en-US': {
    flag: '/assets/flags/uk.svg',
    name: 'English'
  }
}

export { countries }
